import { FormControl, FormControlLabel, FormLabel, RadioGroup, Radio, Grid } from "@mui/material";
import { CustomStack, CustomToggleSwitch } from "../../../common/components";
import { TIME_COMPARISON } from "../../../common/constants/time-comparison";

// VsComparisonWindow is a functional component that provides a user interface
// for configuring time-based comparisons with toggle switches and radio buttons.
//
// Props:
// - customBooking: Boolean indicating if custom booking logic is enabled.
// - alignmentToggle: Boolean indicating whether day-of-week alignment is enabled.
// - handleToggleChange: Function to handle changes in alignmentToggle.
// - symmetricComparisonToggle: Boolean indicating if symmetric comparison is enabled.
// - dateComparison: The currently selected time comparison option.
// - handleComparisonChange: Function to handle changes in the date comparison option.
// - handleSymmetricComparisonChange: Function to handle changes in symmetricComparisonToggle.


const VsComparisonWindow = ({
  customBooking,
  alignmentToggle,
  handleToggleChange,
  symmetricComparisonToggle,
  dateComparison,
  handleComparisonChange,
  handleSymmetricComparisonChange,
}) => (
  <CustomStack>
    <FormControl>
      <Grid container justifyContent="space-between" flexDirection="row" alignItems="flex-start">
        <Grid item xs={4} paddingTop={1}>
          <FormLabel sx={{ fontSize: 13 }}>VS. Time</FormLabel>
        </Grid>
      </Grid>
      <br />
      <CustomToggleSwitch
        label="Alignment"
        secondaryLabel="day-of-week"
        title="Align day-of-week between selected & comparison stay dates."
        onChange={(event) => handleToggleChange(event)}
        checked={alignmentToggle}
        paddingBottom={3}
      />
      <CustomToggleSwitch
        label="Same Time Last Period"
        title="Use comparable lead-time and booking window between selected & comparison stay dates."
        onChange={handleSymmetricComparisonChange}
        checked={symmetricComparisonToggle}
        paddingBottom={3}
      />
      {dateComparison && (
        <RadioGroup
          disabled
          value={dateComparison}
          onChange={(event) => handleComparisonChange(event)}
        >
          {TIME_COMPARISON?.map((item) => (
            <FormControlLabel
              key={item?.id}
              value={item?.value}
              control={<Radio />}
              label={item?.label}
              disabled={item?.value === "vs OTB" && !customBooking}
              sx={{
                my: -1,
              }}
            />
          ))}
        </RadioGroup>
      )}
    </FormControl>
  </CustomStack>
);
//
export default VsComparisonWindow;
